import { domIdentitiesIterator } from "./iterators.js";
function drawDOMIdentityHeatmap(params) {
  const { renderer, identities, identityToStroke } = params;
  const ctx = renderer.getContext("2d");
  if (ctx === null) throw new Error("Failed to get canvas context");
  ctx.imageSmoothingEnabled = false;
  ctx.clearRect(0, 0, renderer.width, renderer.height);
  for (const element of domIdentitiesIterator(identities)) {
    const width = element.right - element.left;
    const height = element.bottom - element.top;
    ctx.fillStyle = identityToStroke(element.identity);
    ctx.fillRect(element.left, element.top, width, height);
  }
}
export {
  drawDOMIdentityHeatmap
};
//# sourceMappingURL=drawDOMIdentityHeatmap.js.map
